import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface Props {
  title: string;
  count?: number;
  countTone?: 'gold' | 'green' | 'ruby' | 'ink';
  defaultOpen?: boolean;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  description?: string;
}

const COUNT_TONE_CLASS: Record<NonNullable<Props['countTone']>, string> = {
  gold: 'text-gold-600',
  green: 'text-green-700',
  ruby: 'text-ruby-700',
  ink: 'text-ink-500',
};

export function Block({
  title,
  count,
  countTone = 'ink',
  defaultOpen = false,
  headerRight,
  children,
  description,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="bg-white border border-ink-300 rounded-xl mb-4 overflow-hidden shadow-xs">
      <div className="flex items-center justify-between gap-3 px-4 py-3.5">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          className="flex-1 flex items-center gap-2 text-left bg-transparent border-none p-0 cursor-pointer btn-focus rounded-md"
        >
          <ChevronDown
            size={18}
            className={[
              'text-ink-500 transition-transform duration-base ease-out shrink-0',
              open ? 'rotate-0' : '-rotate-90',
            ].join(' ')}
          />
          <span className="font-display font-semibold text-h3 text-ink-900">
            {title}
            {typeof count === 'number' && (
              <span className={`ml-1.5 font-bold ${COUNT_TONE_CLASS[countTone]}`}>
                ({count})
              </span>
            )}
          </span>
        </button>
        {headerRight && (
          <div onClick={(e) => e.stopPropagation()} className="shrink-0">
            {headerRight}
          </div>
        )}
      </div>

      {open && (
        <div className="px-4 pb-4 pt-1">
          {description && <p className="text-small text-ink-500 mb-3">{description}</p>}
          {children}
        </div>
      )}
    </div>
  );
}
